<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "realizado-index"
};
</script>
